import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getClientUnsubscribeApi, postClientUnsubscribeApi } from "../../api/api";
import { ResultShell } from "../cumpleanos/BirthdaySteps";
import "../reservas/reservas.css";
import "../cumpleanos/cumpleanos.css";

const Shell = ({ children }) => <div className="reservas-root bday">{children}</div>;

// The back wraps the body in its usual { isSuccess, status, info } envelope; the venue name is optional.
const venueNameOf = (info) => info?.venue?.name || info?.venueName || info?.businessName || info?.name || "";
const alreadyOut = (info) => info?.unsubscribed === true || info?.status === "opted_out" || info?.optedOut === true || info?.alreadyUnsubscribed === true;

/** Public page of the unsubscribe link (/novedades/baja/:token). Works without login. */
const NewsUnsubscribe = () => {
  const { token } = useParams();
  // status: loading | ready | invalid | error | already | done
  const [state, setState] = useState({ status: "loading", venue: "" });
  const [leaving, setLeaving] = useState(false);
  const [formError, setFormError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    getClientUnsubscribeApi(token)
      .then((res) => {
        if (!active) return;
        const info = res?.data?.info;
        if (res?.data?.isSuccess === false) return setState({ status: "invalid", venue: "" });
        setState({ status: alreadyOut(info) ? "already" : "ready", venue: venueNameOf(info) });
      })
      .catch((err) => {
        if (!active) return;
        // A bad or unknown token looks the same on purpose.
        setState({ status: err?.response?.status === 404 ? "invalid" : "error", venue: "" });
      });
    return () => {
      active = false;
    };
  }, [token, reloadKey]);

  const reload = useCallback(() => {
    setState({ status: "loading", venue: "" });
    setReloadKey((k) => k + 1);
  }, []);

  const leave = async () => {
    if (leaving) return;
    setLeaving(true);
    setFormError("");
    try {
      await postClientUnsubscribeApi(token);
      setState((s) => ({ ...s, status: "done" }));
    } catch (err) {
      if (err?.response?.status === 404) setState({ status: "invalid", venue: "" });
      else setFormError("No pudimos darte de baja. Probá de nuevo.");
    } finally {
      setLeaving(false);
    }
  };

  const { status, venue } = state;
  if (status === "loading") {
    return (
      <Shell>
        <div className="bday-state">
          <Spinner animation="border" />
        </div>
      </Shell>
    );
  }
  if (status === "invalid") {
    return (
      <Shell>
        <ResultShell icon="search" tone="neutral" title="Link inválido o vencido">
          <p>Revisá que lo hayas copiado completo desde el mensaje.</p>
        </ResultShell>
      </Shell>
    );
  }
  if (status === "error") {
    return (
      <Shell>
        <ResultShell icon="alert" tone="danger" title="No pudimos cargar la página">
          <p>Probá de nuevo en unos segundos.</p>
          <div className="bday-state-actions">
            <button type="button" className="r-btn-primary" onClick={reload}>Reintentar</button>
          </div>
        </ResultShell>
      </Shell>
    );
  }
  if (status === "already") {
    return (
      <Shell>
        <ResultShell icon="check" title="Ya te diste de baja">
          <p>No vas a recibir más novedades{venue ? ` de ${venue}` : ""}.</p>
        </ResultShell>
      </Shell>
    );
  }
  if (status === "done") {
    return (
      <Shell>
        <ResultShell icon="check" title="Listo, te diste de baja">
          <p>No vas a recibir más novedades{venue ? ` de ${venue}` : ""}.</p>
        </ResultShell>
      </Shell>
    );
  }

  return (
    <Shell>
      <ResultShell icon="mail" tone="neutral" title="¿Querés dejar de recibir novedades y promociones?">
        <p>{venue ? `Vas a dejar de recibir novedades y promociones de ${venue}.` : "No te vamos a mandar más novedades ni promociones."}</p>
        {formError && <div className="rv-form-error" role="alert">{formError}</div>}
        <div className="bday-state-actions">
          <button type="button" className="r-btn-primary" onClick={leave} disabled={leaving}>
            {leaving ? <Spinner animation="border" size="sm" /> : "Darme de baja"}
          </button>
        </div>
      </ResultShell>
    </Shell>
  );
};

export default NewsUnsubscribe;
